import { TextField, type TextFieldProps } from '@mui/material';
import * as React from 'react';

/**
 * TextField with always-shrunk label that works with react-hook-form.
 * IMPORTANT: forward the ref to the input element (inputRef), not the root.
 */
const ShrinkTextField = React.forwardRef<HTMLInputElement, TextFieldProps>(
  (props, ref) => {
    const { InputLabelProps, ...rest } = props;
    return (
      <TextField
        {...rest}
        inputRef={ref} // <-- RHF register('x').ref lands here
        InputLabelProps={{ shrink: true, ...(InputLabelProps || {}) }}
      />
    );
  }
);

ShrinkTextField.displayName = 'ShrinkTextField';
export default ShrinkTextField;
